module.exports = __webpack_public_path__ + "static/media/sixsense-gallery-7.90107c56.jpg";